import { render } from "./publicDownload.vue?vue&type=template&id=0d4648c2&scoped=true"
import script from "./publicDownload.vue?vue&type=script&lang=js"
export * from "./publicDownload.vue?vue&type=script&lang=js"

import "./publicDownload.vue?vue&type=style&index=0&id=0d4648c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4648c2"]])

export default __exports__